import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  otaMessages(filter) {
    return Api()
      .get('/otamessages', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  otaMessage(id) {
    return Api()
      .get('/otamessage/' + id)
      .then((res) => this.formatRes(res.data));
  },
  create(otaMessage) {
    return Api()
      .post('/otamessage', otaMessage)
      .then((res) => this.formatRes(res.data));
  },
  update(otaMessage) {
    return Api()
      .put('/otamessage/' + otaMessage.id, otaMessage)
      .then((res) => this.formatRes(res.data));
  },
  delete(otaMessage) {
    return Api()
      .delete('/otamessage/' + otaMessage.id)
      .then(() => otaMessage);
  },
  formatRes(e) {
    return e;
  },
};
